var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"collapsible",on:{"click":function($event){_vm.expanded = !_vm.expanded}}},[_c('h3',[_vm._v(" "+_vm._s(_vm.title)+" "),_c('v-icon',[_vm._v(_vm._s(_vm.expanded ? "mdi-chevron-up" : "mdi-chevron-down"))])],1)]),_c('v-expand-transition',[(_vm.expanded)?_c('div',[_vm._t("default")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }